import colors from 'src/assets/theme/colors';
import { styled, Typography } from '@mui/material';

export const StyledText = styled(Typography)`
  color: ${colors.AZT_Light};
`;
